import PropTypes from 'prop-types'
import useTranslation from "../../hooks/useTranslation"
import styled from "styled-components"
import useFormatting from "../../hooks/useFormatting"
import { TableDecorator } from "../table/Table"
import useLocale from "../../hooks/useLocale"

const BooleanSpan = styled.span`
    display: inline-block;
    color: ${({ $positive, theme }) => ($positive ? theme.emotive.success : theme.emotive.error).color};
    background-color: ${({ $positive, theme }) => ($positive ? theme.emotive.success : theme.emotive.error).bg};
    border: 1px solid ${({ $positive, theme }) => ($positive ? theme.emotive.success : theme.emotive.error).border};
    padding: 1px 8px;
    border-radius: 999px;
    font-weight: 600;
    letter-spacing: 0.02em;
    line-height: 1.4;
    font-size: var(--font-XXS);
    font-family: "Prompt", sans-serif;
`

const AmountSpan = styled.span`
    color: ${({ $positive, theme }) => $positive ? theme.font.color : theme.emotive.error.color};
`

const UrlWrapper = styled.div`
    position: relative;
    display: inline-block;
    width: 100%;
`

const UrlTag = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    padding: 0px 0.5rem;
    border-radius: 1rem;
    font-weight: 700;
    font-size: var(--font-XXS);
    font-family: "Prompt", sans-serif;
    color: ${({ theme }) => theme.emotive.success.color};
    background-color: ${({ theme }) => theme.table.chipBg};
    cursor: pointer;
    white-space: nowrap;
    transition: opacity 0.15s;
    z-index: 1;

    ${UrlWrapper}:hover & {
        opacity: 1;
    }
`

const DisplayElement = ({ string, type = '', item, col, prefix = null }) => {
    const { t } = useTranslation()
    const { formatString } = useFormatting()
    const { toNumber } = useLocale()

    let result = formatString(string, type, item, col)
    if (prefix) result = t(prefix) + result

    const renderBoolean = () => (
        <BooleanSpan $positive={!!item?.[col?.id]}>
            {result}
        </BooleanSpan>
    )

    const renderAmount = () => {
        const isPositive = toNumber(result) >= 0
        return (
            <AmountSpan $positive={isPositive}>
                {result}
                {item && col?.decorator && <TableDecorator>{item[col.decorator]}</TableDecorator>}
            </AmountSpan>
        )
    }

    const renderLink = () => (
        <a href={result} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
            {result}
        </a>
    )

    const renderUrl = () => {
        if (!result) return <span>—</span>
        return (
            <UrlWrapper>
                <span>{result}</span>
                <UrlTag
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                        window.open(result, '_blank', 'noopener,noreferrer')
                    }}
                >
                    {t(col?.linkLabel || 'portal.list.line.open')}
                </UrlTag>
            </UrlWrapper>
        )
    }

    const renderDefault = () => <span>{result}</span>

    switch (type) {
        case 'boolean':
            return renderBoolean()
        case 'amount':
            return renderAmount()
        case 'link':
            return renderLink()
        case 'url':
            return renderUrl()
        default:
            return renderDefault()
    }
}

export default DisplayElement
